import React, { FC } from 'react';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './header_logo.module.scss';

type Props = {
  source: string;
};

export const HeaderLogo: FC<Props> = ({ source, children }) => (
  <Hyperlink
    className={styles.logo}
    href="/"
    source={source}
    onClick={() => {
      doctrineAnalytics('Nav DoctrineLogoClicked');
    }}
  >
    {children}
  </Hyperlink>
);
